// tslint:disable-next-line: ter-arrow-parens
export const getSelectStyleForSelectWithInput = ({ height }: { height?: string } = {}) => {
  return {
    '&.ant-select .ant-select-selector': {
      // background: '#eee',
      background: '#fafafa',
      display: 'flex',
      alignItems: 'center',
      height: height || 'auto',
    },
    '& .ant-select-arrow': {
      color: 'inherit',
    },
  };
};
export const getImportantPosition = (pos: string): any => {
  return `${pos} !important`;
};

export const getTextInputStyleForSelectWithInput = () => ({
  '& .ant-input': {
    borderRadius: '0 4px 4px 0',
  },
});

export const tablePaginationStyle = () => ({
  '& .ant-table-pagination': {
    marginRight: '10px !important',
  },
});

export const refreshButton = ({ color }) => ({
  color: color || 'grey',
  background: 'transparent',
  border: 'none',
  boxShadow: 'none',
  fontSize: 18,
  margin: '10px 0 0 0',
  '&:hover': {
    border: 'none',
    background: 'transparent !important',
    boxShadow: 'none',
  },
  '&:focus': {
    backgroundColor: 'transparent',
  },
});

export const getSelectStyleForNoLeftRadius = () => ({
  '& .ant-select-selection': {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
});

export const getAntdTableComponentsStyle = () => {
  return {
    '& .ant-checkbox-inner': {
      width: '15px',
      height: '15px',
    },
    '& .anticon-down': {
      fontSize: '12px',
    },
  };
};
